// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ju-1";
export var messageSideRight = "_ju-2";
export var orderLookupBubbleContainer = "_ju-0";
export var submitButton = "_ju-3";